import packageJson from '../../package.json';

export function getClientMetadataHeaders(): Record<string, string> {
  return {
    'X-Client-Platform': 'web',
    'X-Client-Version': packageJson.version,
  };
}
